"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _stripUnit = _interopRequireDefault(require("../../utils/stripUnit"));

var _Input = _interopRequireDefault(require("../Input"));

var _Option = _interopRequireDefault(require("./Option"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tvertical-align: top;\n\tpadding-right: ", " !important;\n\toutline: none;\n\tbackground-color: ", ";\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='", "' height='", "' viewBox='0 0 20 20'%3E %3Cpath d='M10 1l-5 7h10l-5-7zM10 19l5-7h-10l5 7z' fill='%23", "'%3E%3C/path%3E %3C/svg%3E\");\n\tbackground-repeat: no-repeat;\n\tbackground-position: right 5px center;\n\n\t", "\n\n\t&&::-ms-expand {\n\t\tdisplay: none;\n\t}\n\n    -moz-appearance: none;\n\n\t&.option {\n\t\tfont-family: ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var size = (0, _stripUnit.default)(_spacing.default.s2);

var arrowColour = _colors.default.borderColor.slice(1);

var Box = (0, _styledComponents.default)(_Input.default.withComponent('select'))(_templateObject(), _spacing.default.s4, _colors.default.white, size, size, arrowColour, function (_ref) {
  var placeholder = _ref.placeholder,
      value = _ref.value;
  return placeholder && value === '' && "color: " + _colors.default.placeholder + "; font-family: " + _vars.default.fontStackNormal + ";";
}, _vars.default.fontStackNormal);
Box.displayName = 'Box';

var Select = function Select(_ref2) {
  var children = _ref2.children,
      name = _ref2.name,
      gaAction = _ref2.gaAction,
      gaTrackValue = _ref2.gaTrackValue,
      placeholder = _ref2.placeholder,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "name", "gaAction", "gaTrackValue", "placeholder"]);

  props['data-track-action'] = gaAction;

  if (gaTrackValue) {
    props['data-track-value'] = 'on';
  }

  return _react.default.createElement(Box, _extends({
    name: name,
    placeholder: placeholder
  }, props), placeholder && _react.default.createElement(_Option.default, {
    key: "placeholder",
    disabled: true,
    value: ""
  }, placeholder), children);
};

Select.displayName = 'Select';
Select.propTypes = {
  children: _propTypes.node.isRequired,
  name: _propTypes.string.isRequired,
  gaAction: _propTypes.string,
  gaTrackValue: _propTypes.bool,
  placeholder: _propTypes.string
};
Select.defaultProps = {
  gaAction: '',
  gaTrackValue: false,
  placeholder: undefined
};
var _default = Select;
exports.default = _default;